export const USER_REFS = {
  ACCESS_TOKEN: 'ACT',
};

export const setToken = (token) => {
  return localStorage.setItem(USER_REFS.ACCESS_TOKEN, token);
};
export const getToken = () => {
  return localStorage.getItem(USER_REFS.ACCESS_TOKEN);
};
